import { Capacitor } from '@capacitor/core';
import { Photo } from '@watchduty/camera';
import { getData, LOCAL_STORAGE_KEY, saveData } from 'state/localStorage';

/**
 * Draft for recovering an in-progress photo report if Android kills our process while the
 * camera Activity is in the foreground (see RestoredPhotoListener). Never stores image bytes,
 * `Photo.path` is enough to rebuild the file later via `readFilePath()`.
 */
export type PhotoSubmissionDraft = {
  route: string;
  message: string;
  photo?: Photo;
};

/**
 * The draft only exists to feed Capacitor's `appRestoredResult` recovery, which is Android-only
 * (see RestoredPhotoListener), so there's nothing to recover from a draft on any other platform.
 */
export const isPhotoDraftRecoverySupported = (): boolean =>
  Capacitor.getPlatform() === 'android';

export const getPhotoSubmissionDraft = (): PhotoSubmissionDraft | undefined =>
  getData<PhotoSubmissionDraft>(LOCAL_STORAGE_KEY.PHOTO_SUBMISSION_DRAFT);

export const savePhotoSubmissionDraft = (draft: PhotoSubmissionDraft): void => {
  saveData(LOCAL_STORAGE_KEY.PHOTO_SUBMISSION_DRAFT, draft);
};

export const clearPhotoSubmissionDraft = (): void => {
  localStorage.removeItem(LOCAL_STORAGE_KEY.PHOTO_SUBMISSION_DRAFT);
};

export const attachPhotoToDraft = (
  photo: Photo,
): PhotoSubmissionDraft | undefined => {
  const draft = getPhotoSubmissionDraft();
  if (!draft) return undefined;

  const updated: PhotoSubmissionDraft = { ...draft, photo };
  savePhotoSubmissionDraft(updated);
  return updated;
};
